<div class="loader-container" [class.loader-mini]="mini">
    <div class="loader">
        <i class="fas fa-circle-notch fa-spin"></i>
    </div>
</div>
